var map = {
	"./locale-at.json": 50,
	"./locale-cz.json": 54,
	"./locale-de.json": 44,
	"./locale-dk.json": 51,
	"./locale-ee.json": 47,
	"./locale-es.json": 45,
	"./locale-fi.json": 53,
	"./locale-fr.json": 43,
	"./locale-gb.json": 27,
	"./locale-lt.json": 49,
	"./locale-lv.json": 48,
	"./locale-nl.json": 42,
	"./locale-pl.json": 55,
	"./locale-pt.json": 46,
	"./locale-se.json": 52,
	"./locale-sk.json": 56
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 134;